import React, {Component} from 'react';
import {Spinner} from '../widgets';
import {CommunityCard} from '../community';
import {fetchJson} from '../fetchJson';
import {ProfileCard} from '../profile';

import './SuggestionCard.css';

class SuggestionCard extends Component {
	constructor() {
		super();

		this.state = {
			shown: 0,
			direction: true, // forwards
			suggestions: []
		};
	}

	componentDidMount() {
		fetchJson('/api/community/gen-suggestions').then(data => {
			if (this.props.providers) {
				const providers = data.reduce((acc, curr) => {
					acc.push(...curr.suggestedMembers);
					return acc;
				}, []);
				this.setState(prevState => ({...prevState, suggestions: providers}));
			} else {
				this.setState(prevState => ({...prevState, suggestions: data}));
			}
		});
	}

	nextItem = () => {
		if (!this.len()) return;
		// Increment shown feature index
		this.setState({
			shown: (this.state.shown + 1) % this.len(),
			direction: true // forwards
		});
	};

	previousItem = () => {
		if (!this.len()) return;
		// Increment shown feature index
		this.setState({
			shown: (this.state.shown + this.len() - 1) % this.len(),
			direction: false // backwards
		});
	};

	isIndexShown = (shownIdx, idx) => {
		if (idx === shownIdx) return 'shown';
		if (idx === Math.max((shownIdx + this.len() - 1) % this.len())) return 'hidden';
		return 'prehidden';
	};

	len = () => (this.state.suggestions ? this.state.suggestions.length : 0);

	render() {
		const {providers = false} = this.props;
		const {suggestions} = this.state;

		return (
			<article
				className={`SuggestionCard ${
					this.state.direction ? 'direction-forwards' : 'direction-backwards'
				} ${providers ? 'provider' : 'community'}`}>
				<header className="SuggestionCard-Header">
					<h2>Suggested {providers ? 'providers' : 'communities'} for you</h2>
				</header>

				<div className="SuggestionCard-Body">
					{suggestions ? (
						<React.Fragment>
							<button onClick={this.previousItem}>&lt;</button>
							<ol>
								{suggestions.map((s, idx) => (
									<li
										key={s.uuid}
										className={`suggestionItem ${this.isIndexShown(this.state.shown, idx)}`}>
										{providers ? <ProfileCard provider={s} /> : <CommunityCard community={s} />}
									</li>
								))}
							</ol>
							<button onClick={this.nextItem}>&gt;</button>
						</React.Fragment>
					) : (
						<Spinner />
					)}
				</div>
			</article>
		);
	}
}

export default SuggestionCard;



// WEBPACK FOOTER //
// ./src/stream/SuggestionCard.js